import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
import { ArgumentOutOfRangeException } from "../../shared/index.js";
export const chunk = (source, size) => {
    if (size < 1) {
        throw new ArgumentOutOfRangeException("size");
    }
    async function* iterator() {
        let yieldChunk = [];
        for await (const value of source) {
            yieldChunk.push(value);
            if (yieldChunk.length === size) {
                yield yieldChunk;
                yieldChunk = [];
            }
        }
        if (yieldChunk.length) {
            yield yieldChunk;
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
